import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MaintenanceState {
  isOnMaintenance: boolean
  bypassMaintenance: boolean
  title?: string
  message?: string
}

const initialState: MaintenanceState = {
  isOnMaintenance: false,
  bypassMaintenance: false,
  title: '',
  message: '',
}

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.isOnMaintenance = action.payload
    },
    setBypassMaintenance: (state, action: PayloadAction<boolean>) => {
      state.bypassMaintenance = action.payload
    },
    setMaintenanceInfo: (
      state,
      action: PayloadAction<{ title?: string; message?: string }>
    ) => {
      state.title = action.payload.title || 'Maintenance'
      state.message =
        action.payload.message || 'The site is currently under maintenance.'
    },
  },
})

export const { setMaintenanceMode, setBypassMaintenance, setMaintenanceInfo } =
  maintenanceSlice.actions
export default maintenanceSlice.reducer
